import { useEffect, useMemo, useState } from 'react'
import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'
import { api, mediaUrl } from '@/lib/api'

export default function BlogAdmin() {
  const [rows, setRows] = useState([])
  const [editing, setEditing] = useState(null)
  const [file, setFile] = useState(null)
  const [form, setForm] = useState({
    title: '', excerpt: '', content: '', category: 'News', author: 'Fortino Tech',
    isPublished: '1', isFeatured: '0',
  })

  const modules = useMemo(() => ({
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'blockquote'],
      ['clean'],
    ],
  }), [])

  const load = async () => {
    const { data } = await api.get('/blog/admin')
    setRows(data.data || [])
  }

  useEffect(() => { load().catch(() => setRows([])) }, [])

  const save = async (e) => {
    e.preventDefault()
    const body = new FormData()
    Object.entries(form).forEach(([k, v]) => body.append(k, v))
    body.append('folder', 'blog')
    if (file) body.append('image', file)
    if (editing === 'new') await api.post('/blog', body)
    else await api.put(`/blog/${editing.id}`, body)
    setEditing(null)
    await load()
  }

  return (
    <div>
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">Blog / News</h1>
        <button onClick={() => { setEditing('new'); setForm({ title: '', excerpt: '', content: '', category: 'News', author: 'Fortino Tech', isPublished: '1', isFeatured: '0' }); setFile(null) }} className="admin-btn">Add article</button>
      </div>

      {editing && (
        <form onSubmit={save} className="bg-slate-900 border border-slate-800 rounded-2xl p-5 mb-6 space-y-4">
          <input className="w-full px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <textarea className="w-full px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" placeholder="Short excerpt" value={form.excerpt} onChange={(e) => setForm({ ...form, excerpt: e.target.value })} />
          <div className="bg-white text-slate-900 rounded-xl overflow-hidden">
            <ReactQuill theme="snow" value={form.content} onChange={(content) => setForm({ ...form, content })} modules={modules} />
          </div>
          <div className="grid md:grid-cols-4 gap-3">
            <input className="px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" placeholder="Category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} />
            <input className="px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" placeholder="Author" value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} />
            <select className="px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" value={form.isPublished} onChange={(e) => setForm({ ...form, isPublished: e.target.value })}>
              <option value="1">Published</option>
              <option value="0">Draft</option>
            </select>
            <select className="px-3 py-2 rounded-xl bg-slate-800 border border-slate-700" value={form.isFeatured} onChange={(e) => setForm({ ...form, isFeatured: e.target.value })}>
              <option value="0">Not featured</option>
              <option value="1">Featured on home</option>
            </select>
          </div>
          <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
          <div className="flex gap-3">
            <button className="px-4 py-2 rounded-xl bg-blue-600">Save</button>
            <button type="button" onClick={() => setEditing(null)} className="px-4 py-2 rounded-xl bg-slate-800">Cancel</button>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {rows.map((row) => (
          <div key={row.id} className="bg-slate-900 border border-slate-800 rounded-2xl p-4 flex gap-4 items-center">
            {row.featuredImage && <img src={mediaUrl(row.featuredImage)} alt="" className="w-20 h-16 object-cover rounded-lg" />}
            <div className="flex-1">
              <p className="font-semibold">{row.title}</p>
              <p className="text-xs text-slate-400">{row.category} · {row.isPublished ? 'Published' : 'Draft'} · {row.isFeatured ? 'Featured' : ''}</p>
            </div>
            <button className="text-blue-400" onClick={() => { setEditing(row); setForm({ title: row.title, excerpt: row.excerpt || '', content: row.content || '', category: row.category, author: row.author, isPublished: row.isPublished ? '1' : '0', isFeatured: row.isFeatured ? '1' : '0' }) }}>Edit</button>
            <button className="text-red-400" onClick={async () => { if (confirm('Delete?')) { await api.delete(`/blog/${row.id}`); await load() } }}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  )
}
